
import Vue from 'vue'

import GardenCard from '@/ui/components/gardens/GardenCard.vue'

export default Vue.extend({
  components: {
    GardenCard,
  },
  data: () => ({
    // gardens: gardens,
  }),
  computed: {
    gardens() {
      return this.$store.getters['gardens/all']
    },
  },
})
